<template>
  <div>
    <notice-modal
      ref="noticeForm"
      id="notice-form"
      :title="titleForm"
      :is-loading="isLoadingGrid"
      :notice-types="noticeTypes"
      :notice="notice"
      @on-create="handleCreate"
      @on-update="handleUpdate"
    />

    <bita-breadcrumb :items="breadCrumbs" />

    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">

          <div class="row mb-4 bg-light p-3 rounded border">
            <div class="col-12 mb-2">
              <strong>فیلتر مناقصه/مزایده:</strong>
            </div>

            <div class="col-lg-4 mb-3">
              <label>نوع</label>
              <select v-model="filters.notice_type" class="form-control">
                <option value="">همه</option>
                <option value="tender">مناقصه</option>
                <option value="auction">مزایده</option>
              </select>
            </div>

            <div class="col-lg-4 mb-3">
              <label>وضعیت</label>
              <select v-model="filters.status" class="form-control">
                <option value="">همه</option>
                <option value="draft">پیش‌نویس</option>
                <option value="published">فعال</option>
                <option value="closed">پایان‌یافته</option>
                <option value="cancelled">لغوشده</option>
              </select>
            </div>

            <div class="col-lg-4 d-flex align-items-end mb-3">
              <bita-bootbutton type="info" title="جستجو" icon="fas fa-search" @click.native="loadData" />
              <bita-bootbutton type="default" title="پاک کردن" class="mr-2" @click.native="clearFilters" />
            </div>
          </div>

          <hr />

          <div class="d-flex flex-wrap mb-3">
            <bita-bootbutton
              type="primary"
              title="ثبت مناقصه / مزایده جدید"
              icon="fas fa-plus-square"
              btn-width="220px"
              @click.native="createNotice"
            />
          </div>

          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :page-size="pageSize"
            :current-page="currentPage"
            :has-row-number="true"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>

<script>
import noticesApi from '../../../api/tender/noticesApi';
import NoticeModal from './components/NoticeModal.vue';

export default {
  components: { NoticeModal },
  data() {
    return {
      pageSize: 15,
      currentPage: 1,
      titleForm: '',
      isLoadingGrid: false,

      noticeTypes: [
        { id: 'tender', name: 'مناقصه' },
        { id: 'auction', name: 'مزایده' },
      ],

      breadCrumbs: [
        { title: 'صفحه اصلی', link: '/' },
        { title: 'مدیریت مناقصه/مزایده', link: '/admin/notices', active: true },
      ],

      notice: {},
      filters: {
        notice_type: '',
        status: '',
      },
    };
  },

  computed: {
    gridColumns() {
      return [
        {
          field: 'title',
          title: 'عنوان',
          template: ({ title }) => title || ' - ',
        },
        {
          field: 'notice_type',
          title: 'نوع',
          template: ({ notice_type }) => {
            if (notice_type === 'tender') return '<span class="badge badge-info">مناقصه</span>';
            if (notice_type === 'auction') return '<span class="badge badge-warning">مزایده</span>';
            return ' - ';
          },
        },
        {
          field: 'product_code',
          title: 'کد محصول',
          template: ({ product_code }) => product_code || ' - ',
        },
        {
          field: 'starts_at',
          title: 'تاریخ شروع',
          template: ({ starts_at }) => starts_at ? this.$getJalaliDate(starts_at) : ' - ',
        },
        {
          field: 'ends_at',
          title: 'تاریخ پایان',
          template: ({ ends_at }) => ends_at ? this.$getJalaliDate(ends_at) : ' - ',
        },
        {
          field: 'status',
          title: 'وضعیت',
          template: ({ status }) => this.statusBadge(status),
        },
        {
          title: 'عملیات',
          command: this.gridCommands(),
        },
      ];
    },
  },

  mounted() {
    this.loadData();
  },

  methods: {
    statusBadge(status) {
      if (status === 'draft') return '<span class="badge badge-secondary">پیش‌نویس</span>';
      if (status === 'published') return '<span class="badge badge-success">فعال</span>';
      if (status === 'closed') return '<span class="badge badge-dark">پایان‌یافته</span>';
      if (status === 'cancelled') return '<span class="badge badge-danger">لغوشده</span>';
      return ' - ';
    },

    clearFilters() {
      this.filters.notice_type = '';
      this.filters.status = '';
      this.loadData();
    },

    toggleModal() {
      this.$toggleModal('#notice-form');
    },

    loadData() {
      this.$refs.grid.loadDataSource();
    },

    readData(e) {
      this.$resetGrid();
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.isLoadingGrid = true;

      const queryParams = {
        page_size: this.pageSize,
        page: this.currentPage,
        ...this.filters,
      };

      noticesApi.get(queryParams)
        .then(({ data }) => {
          e.success(data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },

    createNotice() {
      this.notice = {};
      this.$refs.noticeForm.reset();
      this.titleForm = 'ثبت مناقصه / مزایده جدید';
      this.toggleModal();
    },

    edit(e) {
      this.notice = this.$refs.grid.getSelectedGridRow(e);
      this.$refs.noticeForm.setFormData(this.notice);
      this.titleForm = 'ویرایش مناقصه / مزایده';
      this.toggleModal();
    },

    handleCreate(data) {
      this.isLoadingGrid = true;

      const formData = this.getFormData(data);

      noticesApi.create(formData)
        .then(() => {
          this.$izitoast('success', 'عملیات موفق', 'مناقصه/مزایده با موفقیت ثبت شد.');
          this.toggleModal();
          this.loadData();
        })
        .catch((err) => {
          this.handleApiErrors(err);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },

    handleUpdate(data) {
      this.isLoadingGrid = true;

      const formData = this.getFormData(data);

      noticesApi.update(data.id, formData)
        .then(() => {
          this.$izitoast('success', 'عملیات موفق', 'اطلاعات با موفقیت بروزرسانی شد.');
          this.toggleModal();
          this.loadData();
        })
        .catch((err) => {
          this.handleApiErrors(err);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },

    delete(e) {
      const data = this.$refs.grid.getSelectedGridRow(e);

      this.$alert('question', `آیا از حذف "${data.title}" اطمینان دارید؟`, '', {
        confirmButtonText: 'بله',
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;

          noticesApi.delete(data.id)
            .then(() => {
              this.$izitoast('success', 'عملیات موفق', 'رکورد حذف شد.');
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },

    viewBids(e) {
      const data = this.$refs.grid.getSelectedGridRow(e);
      this.$router.push(`/tender/notices/${data.id}/bids`);
    },

    getFormData(data) {
      const formData = new FormData();

      for (const key in data) {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      }

      return formData;
    },

    handleApiErrors(err) {
      if (err.response && err.response.data && err.response.data.errors) {
        this.$refs.noticeForm.setErrors(err.response.data.errors);
      } else if (err.response && err.response.data && err.response.data.message) {
        this.$izitoast('error', 'خطا', err.response.data.message);
      }
    },

    gridCommands() {
      return [
        { text: 'edit', click: this.edit, template: this.gridButtons.edit },
        { text: 'delete', click: this.delete, template: this.gridButtons.delete },
        { text: 'prices', click: this.viewBids, template: this.gridButtons.prices },
      ];
    },
  },
};
</script>